import PropTypes from 'prop-types';

// ---------------------------------------------------------------------------
// Shapes dos payloads de /billing/analytics/* e do envelope de bloco do hook.
//
// Ficam num módulo só porque descrevem o CONTRATO, não um componente: quando o
// backend mudar um campo, o lugar de atualizar é aqui, e não em cinco arquivos.
// Também servem de documentação executável — `taxa_pct` declarado como number
// (podendo faltar) é o lembrete de que ele vem `null` de verdade.
// ---------------------------------------------------------------------------

// { titulos, valor } — o par que se repete em todo o contrato.
export const countAmountShape = PropTypes.shape({
   titulos: PropTypes.number,
   valor: PropTypes.number,
});

export const apiErrorShape = PropTypes.shape({
   code: PropTypes.string,
   message: PropTypes.string,
   status: PropTypes.number,
   errorId: PropTypes.string,
   fieldErrors: PropTypes.objectOf(PropTypes.string),
});

export const dataQualityShape = PropTypes.shape({
   emission_date_field: PropTypes.string,
   historical_load_until: PropTypes.string,
   future_points_are_null: PropTypes.bool,
   notes: PropTypes.arrayOf(PropTypes.string),
});

export const summaryShape = PropTypes.shape({
   reference_date: PropTypes.string,
   date_basis: PropTypes.string,
   emitido: countAmountShape,
   ticket_medio: PropTypes.number,
   recebido: countAmountShape,
   adimplencia_em_dia: PropTypes.shape({
      pagos_ate_vencimento: PropTypes.number,
      vencidos_no_periodo: PropTypes.number,
      taxa_pct: PropTypes.number, // pode vir null
   }),
   recuperacao: PropTypes.shape({
      pagos_apos_vencimento: PropTypes.number,
      valor: PropTypes.number,
      taxa_pct: PropTypes.number, // pode vir null
   }),
   atraso_medio_dias: PropTypes.number, // pode vir null
   dso_dias: PropTypes.number, // pode vir null
   // `reducao_negociada` foi REMOVIDO do contrato: dos R$ 160 mil que somava,
   // 89% vinham de dois títulos com erro de vírgula. Era correção de digitação
   // com nome de política financeira. Volta se a edição de valor passar a
   // exigir motivo — e aí é campo novo da API, não cálculo do front.
   cancelado: countAmountShape,
   data_quality: dataQualityShape,
});

export const agingShape = PropTypes.shape({
   as_of: PropTypes.string,
   date_basis: PropTypes.string,
   a_vencer: countAmountShape,
   buckets: PropTypes.arrayOf(
      PropTypes.shape({
         bucket: PropTypes.string,
         titulos: PropTypes.number,
         valor: PropTypes.number,
      }),
   ),
   vencido: PropTypes.shape({
      titulos: PropTypes.number,
      valor: PropTypes.number,
      share_da_carteira_pct: PropTypes.number,
   }),
   total_em_aberto: countAmountShape,
   data_quality: dataQualityShape,
});

// Envelope que o `useCreditSalesData` entrega por bloco.
export function blockShape(dataShape) {
   return PropTypes.shape({
      data: dataShape,
      loading: PropTypes.bool,
      error: apiErrorShape,
   });
}
